import React from 'react';
import { Header } from './styles';
import PdsIcon from '../../images/pds-icon.svg';

const TitleBanner = props => {
  const { title, imgUrl, small, medium, large } = props;
  return (
    <Header small={small} medium={medium} large={large}>
      <img src={imgUrl ? imgUrl : PdsIcon} alt="Logo" className="logo" />
      <h2 className="title">{title ? title : 'company'}</h2>
    </Header>
  );
};

export default TitleBanner;
